import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/login' // Redirige la ruta raíz a la página de inicio de sesión
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login.vue'),
    meta: { public: true }
  },
  {
    path: '/confirmacionPresupuesto/:hash',
    name: 'confirmacionPresupuesto',
    component: () => import('../views/ConfirmacionPresupuesto.vue'),
    meta: { public: true }
  },

  {
    path: '/consultarAgenciaPresupuesto/:hash',
    name: 'consultarAgenciaPresupuesto',
    component: () => import('../views/ConsultarAgenciaPresupuesto.vue'),
    meta: { public: true }
  },
  
  {
    path: '/TiempoReal',
    name: 'TiempoReal',
    component: () => import('../views/EnConstruccion.vue'),
    meta: { public: false }
  },
  {
    path: '/Expedientes',
    name: 'Expedientes',
    component: () => import('../views/EnConstruccion.vue'),
    meta: { public: false }
  },
  {
    path: '/Presupuestos',
    name: 'Presupuestos',
    component: () => import('../views/Presupuestos.vue'),
    meta: { public: false }
  },
  {
    path: '/Reservas',
    name: 'Reservas',
    component: () => import('../views/Reservas.vue'),
    meta: { public: false }
  },
  {
    path: '/Clientes',
    name: 'Clientes',
    component: () => import('../views/Clientes.vue'),
    meta: { public: false }
  },

  {
    path: '/Caminos',
    name: 'Caminos',
    component: () => import('../views/Caminos.vue'),
    meta: { public: false }
  },
  {
    path: '/Puntos',
    name: 'Puntos',
    component: () => import('../views/EnConstruccion.vue'),
    meta: { public: false }
  },
  {
    path: '/Alojamientos',
    name: 'Alojamientos',
    component: () => import('../views/Alojamientos.vue'),
    meta: { public: false }
  },
  {
    path: '/Proveedores',
    name: 'Proveedores',
    component: () => import('../views/Proveedores.vue'),
    meta: { public: false }
  },
  {
    path: '/ProveedoresReglasTarifas',
    name: 'ProveedoresReglasTarifas',
    component: () => import('../views/ProveedoresReglasTarifas.vue'),
    meta: { public: false }
  },
  {
    path: '/Agencias',
    name: 'Agencias',
    component: () => import('../views/Agencias.vue'),
    meta: { public: false }
  },
  {
    path: '/Incidencias',
    name: 'Incidencias',
    component: () => import('../views/EnConstruccion.vue'),
    meta: { public: false }
  },
  {
    path: '/Ayuda',
    name: 'Ayuda',
    component: () => import('../views/EnConstruccion.vue'),
    meta: { public: false }
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
 
  const isAuthenticated = store.state.auth.isLogged; // Verifica si el usuario está autenticado
  
  if (to.matched.some(record => record.meta.public)) {
    //console.log('ruta publica', to);
    next()
    return
  }

  //console.log('ambas', to.matched.some(record => record.meta.public) && !isAuthenticated);

  if (!to.matched.some(record => record.meta.public) && !isAuthenticated) {
    //console.log('ruta no publica y no autenticada', to);
    next('/login')
    return
  }

  next()
  
  
});



export default router
